import downloadFile from './downloadTextFile';

interface DownloadJSONProps {
  data: Array<string> | string;
  filename?: string;
}

const downloadJSON = ({ data, filename = 'download.json' }: DownloadJSONProps) =>
  downloadFile({ data, filename, type: 'application/json;charset-UTF-8' });

export default downloadJSON;
